import type { FC, SVGProps } from "react";

const IconPhone: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg viewBox="0 0 14 20" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" {...props}>
    <path d="M11.167 1.66602H2.83366C1.91318 1.66602 1.16699 2.41221 1.16699 3.33268V16.666C1.16699 17.5865 1.91318 18.3327 2.83366 18.3327H11.167C12.0875 18.3327 12.8337 17.5865 12.8337 16.666V3.33268C12.8337 2.41221 12.0875 1.66602 11.167 1.66602Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M7 15H7.00833" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
);

export default IconPhone;
